import { render, staticRenderFns } from "./ExamineView.vue?vue&type=template&id=1faa8a6a"
import script from "./ExamineView.vue?vue&type=script&lang=js"
export * from "./ExamineView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports